import { fetchTokens } from '@avnu/avnu-sdk';
import { AVNUToken } from '../../interfaces';
import { createAsyncAtom } from '../../lib/state';

export type AVNUTokenConfig = Record<string, AVNUToken>;

const avnuSupportedTokensAtom = createAsyncAtom<AVNUTokenConfig>(
  async () => {
    try {
      const pages = await fetchTokens();
      const tokens = pages.content;

      const avnuTokens = tokens
        .filter(token => token.address !== '0x0')
        .reduce((config, token) => {
          return {
            ...config,
            [token.symbol]: token,
          };
        }, {} as AVNUTokenConfig);

      avnuTokens['EKUBO'].logoUri = 'https://assets.coingecko.com/coins/images/37715/standard/135474885.png';

      avnuTokens['sSTRK'] = {
        address: '0x0356f304b154d29d2a8fe22f1cb9107a9b564a733cf6b4cc47fd121ac1af90c9',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'sSTRK',
        logoUri: 'https://nimbora-assets.s3.eu-central-1.amazonaws.com/yieldTokens/Group+41.svg',
        name: 'sSTRK',
      };

      avnuTokens['xSTRK'] = {
        address: '0x028d709c875c0ceac3dce7065bec5328186dc89fe254527084d1689910954b0a',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'xSTRK',
        logoUri: 'https://imagedelivery.net/0xPAQaDtnQhBs8IzYRIlNg/c1f44170-c1b0-4531-3d3b-5f0bacfe1300/logo',
        name: 'xSTRK',
      };

      avnuTokens['STRONK'] = {
        address: '0x02b2ba5da3a25d7e0d45487649a9c4535f29711b57b9054099737e7c9f7dc10a',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'STRONK',
        logoUri: 'https://i.ibb.co/2FkNj39/stronk-starknet-stronknet-pfp-socials.png',
        name: 'STRONK',
      };

      avnuTokens['BRRR'] = {
        address: '0x067737cbee9be3e3042ca86ef41598af7cc36fa6e109193c165b854de07d1df7',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'BRRR',
        logoUri: 'https://i.ibb.co/2yY3wtR/BRRR.png',
        name: 'BRRR',
      };

      avnuTokens['zUSDC'] = {
        address: '0x028757d11c97078dd182023b1cc7b9e7659716c631adf94d24f1fa7dc5943072',
        decimals: 6,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'zUSDC',
        logoUri: 'https://i.ibb.co/mJnYbqm/zUSDC.png',
        name: 'zUSDC',
      };

      avnuTokens['PAL'] = {
        address: '0x049201f03a0f0a9e70e28dcd74cbf44931174dbe3cc4b2ff488898339959e559',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'PAL',
        logoUri: 'https://i.ibb.co/2FmLRBr/pal.png',
        name: 'PAL',
      };

      avnuTokens['TONY'] = {
        address: '0x05f467ace847d1cbc6d1efea978752a8b4549fec043286fec1289d19b8c57e67',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'TONY',
        logoUri: 'https://i.ibb.co/CHqR6JW/TONY.png',
        name: 'TONY',
      };

      avnuTokens['AKU'] = {
        address: '0x0137dfca7d96cdd526d13a63176454f35c691f55837497448fad352643cfe4d4',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'AKU',
        logoUri: 'https://i.ibb.co/RQQspQG/logo-Remi-Baldy.png',
        name: 'AKU',
      };

      avnuTokens['nstSTRK'] = {
        address: '0x04619e9ce4109590219c5263787050726be63382148538f3f936c22aa87d2fc2',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'nstSTRK',
        logoUri: 'https://i.ibb.co/7tkC20b/nstSTRK.png',
        name: 'nstSTRK',
      };

      avnuTokens['UNO'] = {
        address: '0x0719b5092403233201aa822ce928bd4b551d0cdb071a724edd7dc5e5f57b7f34',
        decimals: 18,
        extensions: {},
        lastDailyVolumeUsd: 0,
        tags: [],
        symbol: 'UNO',
        logoUri: 'https://i.ibb.co/Gcw4rsZ/UNO.png',
        name: 'UNO',
      };

      return avnuTokens;
    } catch (e) {
      console.error('Failed to get supported tokens from AVNU', e);
      return {};
    }
  },
  undefined,
  ['user-refresh'],
);

export default avnuSupportedTokensAtom;
